import { get } from 'lodash/fp';
import { get as getCookie, set as setCookie, remove as removeCookie } from 'js-cookie';

const REFERRER_CODE_COOKIE_KEY = 'ds_referrer_code';
const REFERRER_CODE_QUERY_KEY = 'Referrer';

export function saveReferrerCode(code, expires = 7) {
  if (!code) {
    return;
  }

  setCookie(REFERRER_CODE_COOKIE_KEY, code, {
    secure: get('location.protocol', window) === 'https:',
    expires
  });
}

export function getReferrerCode(query) {
  return getReferrerCodeFromQuery(query) || getCookie(REFERRER_CODE_COOKIE_KEY);
}

export function getReferrerCodeFromQuery(queryData) {
  return get(REFERRER_CODE_QUERY_KEY, queryData);
}

export function removeReferrerCode() {
  return removeCookie(REFERRER_CODE_COOKIE_KEY);
}
